import { store } from '../redux/store'
import moment, { Moment } from 'moment'
import { DATE_FORMAT, MONTH_FORMAT, PROVIDER_NETWORKS, SUPPORTED_CURRENCIES } from '../constant'
import queryString from 'query-string'
import { getCalendar } from '../api/common'
import { setCalendarDatesMap, setDisabledDatesMap, setIsDisableCalendar } from '../redux/slices/property'
import { PriceAvailability } from '../interfaces'

const has = Object.prototype.hasOwnProperty

export const isEmpty = (prop: any) => {
  return (
    prop === null ||
    prop === undefined ||
    (has.call(prop, 'length') && prop.length === 0) ||
    (prop.constructor === Object && Object.keys(prop).length === 0)
  )
}

export function isEmailValid(email: string) {
  let re = /^[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\\.]+$/
  return re.test(email)
}

export const isOnlyLetters = (str: string) => {
  // eslint-disable-next-line no-control-regex
  const letters = /^[^\u0000-\u001F\u0021-\u0040\u005B-\u0060\u007B-\u007E\u0080-\u009F\u00A0-\u00BF\u00D7\u00F7]*$/g
  // const letters = /^[a-zA-Z][a-zA-Z\s]*$/
  return str.match(letters)
}

export const isNumber = (str: string) => {
  const numberRegex = /^[0-9]+$/
  return str.match(numberRegex)
}

export const numberWithCommas = (x: number | string) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const convertCurrency = (amount: string) => {
  const result = amount.toString().split('.')
  return `${numberWithCommas(Number(result[0]))}${result[1] ? '.' + result[1] : ''}`
}

export const firstTimeLoadCalendar = async (hostId: string, pmsPropertyId: string) => {
  const parsed = queryString.parse(window.location.search)
  const checkIn = parsed.check_in ? moment(parsed.check_in as string, DATE_FORMAT) : moment()

  const paramsStartDate = moment(checkIn).startOf('months').format(DATE_FORMAT)
  const paramsEndDate = moment(checkIn).add(3, 'month').endOf('months').format(DATE_FORMAT)
  // call api get calendar availability
  try {
    const res = await getCalendar(hostId, pmsPropertyId, paramsStartDate, paramsEndDate)
    store.dispatch(setIsDisableCalendar(false))
    const keyCurrentMonth = moment(checkIn).format(MONTH_FORMAT)
    const keyAddOneMonth = moment(checkIn).add(1, 'month').format(MONTH_FORMAT)
    const keyAddTwoMonth = moment(checkIn).add(2, 'month').format(MONTH_FORMAT)
    const keyAddThreeMonth = moment(checkIn).add(3, 'month').format(MONTH_FORMAT)
    // disabled dates
    const disabledDatesCurrentMonth: any = new Set<string>()
    const disabledDatesAddOneMonth: any = new Set<string>()
    const disabledDatesAddTwoMonth: any = new Set<string>()
    const disabledDatesAddThreeMonth: any = new Set<string>()
    // all calenar dates
    const calendarDatesCurrentMonth: any[] = []
    const calendarDatesAddOneMonth: any[] = []
    const calendarDatesAddTwoMonth: any[] = []
    const calendarDatesAddThreeMonth: any[] = []

    res.data.forEach((item: any) => {
      // const isBlocked = item.status === 'reserved'
      // const isBlocked = item.closedOnCheckin && item.closedOnCheckout
      const isBlocked = !item.bookable && item.closedOnCheckout
      if (isBlocked) {
        if (item.date.includes(keyCurrentMonth)) {
          disabledDatesCurrentMonth.add(item.date)
        }
        if (item.date.includes(keyAddOneMonth)) {
          disabledDatesAddOneMonth.add(item.date)
        }
        if (item.date.includes(keyAddTwoMonth)) {
          disabledDatesAddTwoMonth.add(item.date)
        }
        if (item.date.includes(keyAddThreeMonth)) {
          disabledDatesAddThreeMonth.add(item.date)
        }
      }
      if (item.date.includes(keyCurrentMonth)) {
        calendarDatesCurrentMonth.push(item)
      }
      if (item.date.includes(keyAddOneMonth)) {
        calendarDatesAddOneMonth.push(item)
      }
      if (item.date.includes(keyAddTwoMonth)) {
        calendarDatesAddTwoMonth.push(item)
      }
      if (item.date.includes(keyAddThreeMonth)) {
        calendarDatesAddThreeMonth.push(item)
      }
    })
    const disabledMap = new Map()
    disabledMap.set(keyCurrentMonth, disabledDatesCurrentMonth)
    disabledMap.set(keyAddOneMonth, disabledDatesAddOneMonth)
    disabledMap.set(keyAddTwoMonth, disabledDatesAddTwoMonth)
    disabledMap.set(keyAddThreeMonth, disabledDatesAddThreeMonth)
    store.dispatch(setDisabledDatesMap(disabledMap))

    const calendardMap = new Map()
    calendardMap.set(keyCurrentMonth, calendarDatesCurrentMonth)
    calendardMap.set(keyAddOneMonth, calendarDatesAddOneMonth)
    calendardMap.set(keyAddTwoMonth, calendarDatesAddTwoMonth)
    calendardMap.set(keyAddThreeMonth, calendarDatesAddThreeMonth)
    store.dispatch(setCalendarDatesMap(calendardMap))
  } catch (err: any) {
    console.log('--err calendar---', err)
    if (err?.status === 401) {
      // expired api key
      store.dispatch(setIsDisableCalendar(true))
    }
  }
}

export const loadCalendarNextAndPrev = async ({
  currentDate,
  // type,
  currentCalendardMap,
  currentDisabledMap,
  hostId,
  pmsPropertyId,
}: {
  currentDate: Moment
  type: 'next' | 'prev'
  currentCalendardMap: any
  currentDisabledMap: any
  hostId: string
  pmsPropertyId: string
}) => {
  let start = moment(currentDate).add(0, 'month').startOf('month')
  let end = moment(currentDate).add(2, 'month').endOf('month')
  const paramsStartDate = moment(start).format(DATE_FORMAT)
  const paramsEndDate = moment(end).format(DATE_FORMAT)

  const disabledDates: any = {}
  const calendarDates: any = {}
  // const months = type === 'prev' ? [-3, -2, -1, 0] : [0, 1, 2, 3]
  const months = [0, 1]
  for (let m of months) {
    const key = moment(currentDate).add(m, 'month').format(MONTH_FORMAT)
    disabledDates[key] = new Set()
    calendarDates[key] = []
  }

  // call api get calendar availability
  try {
    const res = await getCalendar(hostId, pmsPropertyId, paramsStartDate, paramsEndDate)
    store.dispatch(setIsDisableCalendar(false))
    res.data.forEach((item: PriceAvailability) => {
      for (let key in calendarDates) {
        if (item.date.includes(key)) {
          calendarDates[key].push(item)
          // const isBlocked = item.closedOnCheckin && item.closedOnCheckout
          const isBlocked = !item.bookable && item.closedOnCheckout
          if (isBlocked) {
            disabledDates[key].add(item.date)
          }
        }
      }
    })
    const cloneDisabledMap = new Map(currentDisabledMap)
    for (let key in disabledDates) {
      cloneDisabledMap.set(key, disabledDates[key])
    }
    store.dispatch(setDisabledDatesMap(cloneDisabledMap))

    const cloneCalendarMap = new Map(currentCalendardMap)
    for (let key in calendarDates) {
      cloneCalendarMap.set(key, calendarDates[key])
    }
    store.dispatch(setCalendarDatesMap(cloneCalendarMap))
  } catch (err: any) {
    if (err?.status === 401) {
      // expired api key
      store.dispatch(setIsDisableCalendar(true))
    }
  }
}

export const getNearestInValidDate = (checkIn: Moment, calendarDatesMap: any) => {
  const groupCalendar = []
  for (let i = 0; i < 12; i++) {
    const nextMonth = moment(checkIn).add(i, 'month')
    const keyMonth = nextMonth.format('YYYY-MM')
    if (Array.isArray(calendarDatesMap.get(keyMonth))) {
      groupCalendar.push(calendarDatesMap.get(keyMonth))
    }
  }
  const fullCalendar = groupCalendar.flatMap((x) => x)
  const indexCheckIn = fullCalendar.findIndex((item: any) => item.date === checkIn.format(DATE_FORMAT))
  if (indexCheckIn === -1) {
    return null
  }
  const length = fullCalendar.length
  let indexNearestInValid
  for (let i = indexCheckIn; i < length; i++) {
    if (!fullCalendar[i].bookable) {
      if (fullCalendar[i].closedOnCheckout) {
        indexNearestInValid = i
      } else {
        indexNearestInValid = i + 1
      }
      break
    }
  }
  return indexNearestInValid && fullCalendar[indexNearestInValid] ? fullCalendar[indexNearestInValid].date : null
}

export const getNearestInValidDateV2 = (checkIn: Moment, dataCalendar: any) => {
  const fullCalendar: any[] = Object.values(dataCalendar)
  const indexCheckIn = fullCalendar.findIndex((item: any) => item.date === checkIn.format(DATE_FORMAT))
  if (indexCheckIn === -1) {
    return null
  }
  const length = fullCalendar.length
  let indexNearestInValid
  for (let i = indexCheckIn; i < length; i++) {
    if (!fullCalendar[i].bookable) {
      if (fullCalendar[i].closedOnCheckout) {
        indexNearestInValid = i
      } else {
        indexNearestInValid = i + 1
      }
      break
    }
  }
  return indexNearestInValid && fullCalendar[indexNearestInValid] ? fullCalendar[indexNearestInValid].date : null
}

export const getAveragePrice7Days = (calendarDatesMap: any) => {
  const groupCalendar = []
  for (let i = 0; i < 2; i++) {
    const nextMonth = moment().add(i, 'month')
    const keyMonth = nextMonth.format('YYYY-MM')
    if (Array.isArray(calendarDatesMap.get(keyMonth))) {
      groupCalendar.push(calendarDatesMap.get(keyMonth))
    }
  }
  const fullAvailable = groupCalendar
    .flatMap((x) => x)
    .filter((x) => moment(x.date, DATE_FORMAT).startOf('day').isSameOrAfter(moment().startOf('day')))
  if (Array.isArray(fullAvailable) && fullAvailable.length > 0) {
    const split7Days = fullAvailable.slice(0, 7)
    const totalPrice7Days = split7Days.reduce((previousValue, currentValue) => {
      return previousValue + currentValue.price
    }, 0)
    return totalPrice7Days / split7Days.length
  }
  return 0
}
export const convertAmPm = (hour: number) => {
  const _hour = Number(hour)
  if (Number.isNaN(_hour)) {
    return hour
  }
  if (_hour !== null && _hour !== undefined) {
    if (_hour === 25) return '01:00 (next day)'
    if (_hour > 12) return `${_hour - 12}` + ':00 PM'
    if (_hour === 12) return '12:00 PM'
    return _hour + ':00 AM'
  }
  return hour
}

export const canParseJSON = (str: any) => {
  try {
    JSON.parse(str)
    return true // can be parsed to JSON
  } catch (error) {
    return false // cannot be parsed to JSON
  }
}

export const convertPriceByCurrency = (
  rateObjBaseOnUsd: any,
  oldCurrency: string,
  newCurrency: string,
  price: number
) => {
  const rateBaseOnUsd = Number(rateObjBaseOnUsd[oldCurrency]?.rate || 1)
  const newRate = rateBaseOnUsd / Number(rateObjBaseOnUsd[newCurrency]?.rate || 1)
  return Math.round(Number(Number(price) * newRate))
}
export const showAbbrevePrice = (price: string | number, currency: string) => {
  return getSymbolCurrencyByKey(currency) + abbreviateNumber(Number(price))
}
export const getSymbolCurrencyByKey = (key?: string) => {
  if (key) {
    const currency = SUPPORTED_CURRENCIES.find(
      (curr) => curr.key === key || curr.key.toUpperCase() === key.toUpperCase()
    )
    if (currency) {
      return currency.symbol
    }
    return ''
  }
  return ''
}

export const abbreviateNumber = (number: number) => {
  const SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E']
  // what tier? (determines SI symbol)
  const tier = (Math.log10(Math.abs(number)) / 3) | 0

  // if zero, we don't need a suffix
  if (tier == 0) return number

  // get suffix and determine scale
  const suffix = SI_SYMBOL[tier]
  const scale = Math.pow(10, tier * 3)

  // scale the number
  const scaled = number / scale

  // format number and add suffix
  return scaled.toFixed(1) + suffix
}

export const renderDates = (checkIn: string | null, checkOut: string | null, defaultText?: string) => {
  if (checkIn && !checkOut) {
    return moment(checkIn, DATE_FORMAT).format('DD MMMM YYYY') + ' - '
  }
  if (!checkIn && checkOut) {
    return ' - ' + moment(checkOut, DATE_FORMAT).format('DD MMMM YYYY')
  }
  if (checkIn && checkOut) {
    const start = moment(checkIn, DATE_FORMAT)
    const end = moment(checkOut, DATE_FORMAT)
    const isSameYearSameMonth = start.format('YYYY-MM') === end.format('YYYY-MM')
    const isSameYearDiffMonth = start.format('YYYY') === end.format('YYYY') && start.format('MM') !== end.format('MM')
    const isDiffYearDiffMonth = start.format('YYYY') !== end.format('YYYY') && start.format('MM') !== end.format('MM')
    if (isSameYearSameMonth) return start.format('DD') + ' - ' + end.format('DD MMMM YYYY')
    if (isSameYearDiffMonth) return start.format('DD MMM') + ' - ' + end.format('DD MMM YYYY')
    if (isDiffYearDiffMonth) return start.format('DD MMM YYYY') + ' - ' + end.format('DD MMM YYYY')
  }
  return defaultText || 'Choose dates...'
}
export const isMobileDevice = (UA?: any) => {
  try {
    const userAgent = UA || navigator.userAgent || navigator.vendor || (window as any).opera
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|WPDesktop/i.test(userAgent)
  } catch (e) {
    return false
  }
}
export const shorterAddress = (address: string) => {
  if (address) {
    return address.substring(0, 10) + '...' + address.substring(address.length - 5)
  }
  return ''
}
export const convertChainIdToNumber = (hexChainId: string) => {
  const item = PROVIDER_NETWORKS.find((v) => v.hex === hexChainId || v.decimal === hexChainId)
  return Number(item?.decimal || 0)
}
